<template>

<a-modal centered v-model:visible="visible" title="" :closable="false" :footer="null"  :afterClose="afterClose">

    <div style="padding: 0px 20px;">
        <div  style="    text-align: center;">
   <div style="    font-size: 16px;">请选择导出类型</div>
    <div style="display: flex;justify-content: center;">
        <a-checkbox-group  style="    display: flex
;" v-model:value="checkedList" :options="articleOptions" class='batchList'>

   </a-checkbox-group>
    </div>




</div>
<div style="    display: flex;
justify-content: flex-end;
align-items: center;margin-top: 1rem;
">

   <a style="margin-right:20px" href="javascript:;" @click="afterClose">取消</a>
   <a-button type="primary" @click="toBatchAgree()" :loading="confirmLoading">确定</a-button>
</div>
    </div>

</a-modal>
</template>
<script setup>


import { createArticleReport } from '@/views/js';
import { message } from 'ant-design-vue/lib/components';
import { ref,watch } from 'vue';

    const showPro = defineProps({
        downloadReport:{
            type:Boolean,
            default:false,
         },
         params:{
            type:Object,
            default:false,
         }
    })
    const showEmit= defineEmits(['toSave','toClose'])
    const visible =ref(false)
    const checkedList=ref(['标题','摘要','正文','附件'])
    const articleOptions=ref(['标题','摘要','正文','附件'
        
    ])
    watch(()=>showPro.downloadReport,(val)=>{
     
         visible.value =val
    })
    const toBatchAgree=()=>{
        var list =[]
        console.log(checkedList.value,'checkedList.value')
        if(checkedList.value&&checkedList.value.length>0){
            for(var i in articleOptions.value){
            if(checkedList.value.indexOf(articleOptions.value[i])>-1){
                list[i]=1
            }
            else{
                list[i]=0
            }
            }
       
            showEmit('toSave',list)
        }
        else{
                message.warning('请选择任一个类型！')
        }
        
       
    }
    const afterClose=()=>{
        showEmit('toClose')
    }

</script>